import React from 'react'

export default function About(props) {
  return (
    <>

      <div className="row mt-3 ">
        <div className="col-md-2"></div>
        <div className="col-md-8 ">

          
            <ul className={`p-3 rounded  shadow bg-${props.mode === "dark" ? "secondary" : "white"} text-${props.mode === "dark" ? "white" : "dark"}`}>
              <h2>{props.about}</h2> <hr />
              <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-10">
                  <li>
                  <b>Text Conversion:</b>
                    <ol>User scan convert text to uppercase or lowercase. This feature is handy for consistent formatting or adjusting the case of input text.</ol>
                  </li>
                  <li>
                  <b>Word and Letter Count:</b>
                    <ol>The utility calculates the number of words and letters in the provided text.
                      Word count helps users understand the length of their content, while letter count provides insight into character density.</ol>
                  </li>
                  <li>
                  <b>Estimated Reading Time:</b>
                    <ol>
                      The utility estimates how long it would take an average person to read the entire text.
                      This feature is valuable for blog posts, articles, or any content where readability matters.
                    </ol></li>
                  <li>
                  <b>Preview and Copy Functionality:</b><ol>
                      Users can see a preview of the processed text before copying it.
                      The one-click copy feature simplifies sharing the modified text.
                    </ol></li>
                  <li>
                    <b>Space Handling:</b>
                    <ol>
                      The utility removes extra spaces (leading, trailing, and consecutive) from the input text.
                      Optionally, it can remove all spaces, which is useful for creating compact strings (e.g., for URLs or hashtags).</ol>
                  </li><li>
                    <b>Clear All Content:</b>
                    <ol>
                      A button to clear all input and reset the utility.
                      Useful when users want to start fresh or remove existing content.</ol>
                  </li>
                </div>
                <div className="col-md-1"></div>
              </div>
            </ul>
        </div>
        <div className="col-md-2"></div>
      </div>

    </>
  )
}
